export default __webpack_public_path__ + "static/media/le_touquet12.c54c67e1.jpg";